import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateTemplate } from '../template.service';
import { logError } from '../../../../lib/utils';
import { CreateBlankTemplateNestedContainer } from './create-blank-template-form-nested.container';
import { ICreateBlankTemplateFormValues } from './create-blank-template-form.component';
import { TEMPLATE_TYPE } from '../../../../lib/types';
import { ROUTE_PATHS } from '../../../../_routes';
import { buildDefaultBlock, buildDefaultSection } from '../../../_editor/_core/editor.const';

export const CreateBlankTemplateContainer = () => {
  const { createTemplate } = useCreateTemplate();
  const navigate = useNavigate();

  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  const handleCreate = useCallback(
    async (props: ICreateBlankTemplateFormValues) => {
      try {
        if (!props.type.length) {
          setSuccess(null);
          setSubmitError('Template type is required');
          return;
        }

        const type = props.type[0].value as TEMPLATE_TYPE;
        const result = await createTemplate({
          ...props,
          version: '1',
          type,
          blocks: [type === TEMPLATE_TYPE.BLOCK ? buildDefaultBlock() : buildDefaultSection()]
        });

        if (result.data?.createTemplate?._id || result.data?.createGlobalTemplate?._id) {
          setSubmitError(null);
          navigate(
            `${ROUTE_PATHS.TEMPLATE}/${result.data?.createTemplate?._id || result.data?.createGlobalTemplate?._id}`
          );
        } else {
          setSuccess(null);
          setSubmitError('Failed to create template');
        }
      } catch (err) {
        const errMsg = 'Failed to create template';
        setSuccess(null);
        setSubmitError(errMsg);
        logError(errMsg, (err as Error).message);
      }
    },
    [createTemplate, navigate]
  );

  return (
    <CreateBlankTemplateNestedContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      onSubmit={handleCreate}
    />
  );
};
